import { Box, IconButton, Modal, makeStyles } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { formatNumber } from "utils/formators";
import { Theme } from "@material-ui/core/styles";
import { CAMPAIGN_CHANNELS_MIN_RECIPIENTS } from "pages/constants";
import { CAMPAIGN_SUBTYPES_ENUM } from "shared/constants";

interface MinimumResidencesModalProps {
  isOpen: boolean;
  onClose: () => void;
  flyersAmount: number;
}

const useStyles = makeStyles((theme: Theme) => ({
  modalContainer: {
    backgroundColor: "white",
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    padding: "24px 16px 32px 16px",
    border: "1px solid #E2E2FC",
    borderRadius: "8px",
    width: "555px",
    [theme.breakpoints.down("md")]: {
      padding: "24px 24px 32px 24px",
      width: "343px",
    },
  },
  modalBox: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
  },
  title: {
    fontWeight: 700,
    fontSize: "24px",
    color: "#0C172C",
    marginTop: "24px",
  },
  subtitle: {
    marginTop: "8px",
    fontSize: "16px",
    color: "#0C172C",
  },
  closeButton: {
    position: "absolute",
    top: 0,
    right: 0,
  },
}));

export const MinimumResidencesModal = ({ isOpen, onClose, flyersAmount }: MinimumResidencesModalProps) => {
  const classes = useStyles();

  return (
    <Modal open={isOpen} onClose={onClose}>
      <Box className={classes.modalContainer}>
        <IconButton onClick={onClose} className={classes.closeButton}>
          <CloseIcon />
        </IconButton>

        <Box className={classes.modalBox}>
          <h1 className={classes.title}>
            Select at least {CAMPAIGN_CHANNELS_MIN_RECIPIENTS[CAMPAIGN_SUBTYPES_ENUM.EDDM].toLocaleString()} residencies
            to continue
          </h1>
          <p className={classes.subtitle}>You currently have {formatNumber(flyersAmount)} residencies selected</p>
        </Box>
      </Box>
    </Modal>
  );
};
